class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const forms = new Set();

    this.allSearchInputs.forEach(input => {
      if (input.form) forms.add(input.form);
    });

    this.input?.addEventListener('focus', this.onInputFocus.bind(this));

    forms.forEach(form => {
      form.addEventListener('reset', this.onFormReset.bind(this));
      form.addEventListener('submit', this.onFormSubmit.bind(this), true);
    });

    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  onFormSubmit(event) {
    const form = event.target;
    const visibleInput = form.querySelector('input[type="search"]');
    const hiddenInput = form.querySelector('input[name="q"]');
    if (!visibleInput || !hiddenInput) return;
    const q = SearchForm.buildStorefrontSearchQuery(visibleInput.value);
    if (!q) return;
    hiddenInput.value = q;
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    this.keepInSync(event.target.value, event.target);
  }

  onInputFocus() {
    if (window.innerWidth < 750) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
